import { useRecoilValue } from 'recoil'

import { useIntl } from 'react-intl'

import { Flex } from 'mailup-web-components'

import {
  MESSAGE_STR_TYPE_CONFIRMATION,
  MESSAGE_STR_TYPE_WELCOME
} from 'Constants/index'

import {
  messageState,
  notificationState
} from 'Pages/OverviewMessage/recoil/state/message'

const getEntityDescription = (Type, intl) => {
  switch (Type) {
    case 'Trigger':
      return intl.formatMessage({ id: 'Load.Common.AutomationTask' })
    case 'DynamicContent':
      return intl.formatMessage({ id: 'Load.NavMenu.DynamicContent' })
    case 'Anagraphic_Filter':
      return intl.formatMessage({ id: 'Load.Common.ProfileFilter' })
    case 'Activity_Filter':
      return intl.formatMessage({ id: 'Load.Common.ActivityFilter' })
    case 'AutomationWorkflow':
      return intl.formatMessage({ id: 'Load.AutomationWorkflow.WorkflowTitle' })
    case 'ABTest':
      return intl.formatMessage({ id: 'Load.Common.ABTestSingularLowercase' })
    case 'Welcome':
      return intl.formatMessage({ id: 'Load.Common.WelcomeMessage' })
    case 'Confirmation':
      return intl.formatMessage({ id: 'Load.Common.ConfirmationRequest' })
    case 'AggregateReport':
      return intl.formatMessage({ id: 'Load.Common.AggregateReport' })
    case 'SubscriptionForm':
      return intl.formatMessage({ id: 'Load.Subscriptions.SubscriptionForm' })
    case 'LandingPage':
      return intl.formatMessage({ id: 'Load.LandingPage.NameNew' })
    case 'SubscriptionFormPopUp':
      return intl.formatMessage({
        id: 'Load.Subscriptions.SubscriptionFormMultichannel'
      })

    case 'None':
    default:
      return ''
  }
}

export const ToggleTooltipContent = () => {
  const intl = useIntl()

  const { activeMessage } = useRecoilValue(notificationState)
  const { messageType, linkedEntities } = useRecoilValue(messageState)

  if (
    !(
      messageType === MESSAGE_STR_TYPE_CONFIRMATION ||
      messageType === MESSAGE_STR_TYPE_WELCOME
    )
  ) {
    return intl.formatMessage({
      id: 'Load.SavedEmailWizard.TooltipNotificationActive'
    })
  }

  if (activeMessage) {
    return intl.formatMessage({
      id: 'Load.MessageOverview.TooltipNotificationActive'
    })
  }

  if (linkedEntities.length > 0) {
    return (
      <div>
        {intl.formatMessage({
          id:
            messageType === MESSAGE_STR_TYPE_CONFIRMATION
              ? 'Load.MessageOverview.TooltipNotificationInUse'
              : 'Load.MessageOverview.TooltipNotificationInUseWelcome'
        })}
        <Flex flexDirection='column' gap='4px' margin='8px 0 0 0'>
          {linkedEntities.map((o, k) => (
            <span key={k}>
              {getEntityDescription(o.Type, intl)}:{' '}
              <strong>
                {intl.formatMessage({ id: 'Load.MailupCommon.Id' })} {o.Id} -{' '}
                {o.Name}
              </strong>
            </span>
          ))}
        </Flex>
      </div>
    )
  }

  return null
}

export default ToggleTooltipContent
